<div class="min-h-screen">
  <header
    class="fixed top-0 left-0 right-0 w-full z-50 bg-primary shadow-sm h-16 md:h-20 transition-all duration-300"
  >
    <div class="max-w-7xl mx-auto px-4 h-full">
      <div class="flex justify-between items-center h-full">
        <a href="/" class="flex-shrink-0 flex items-center group">
          <img
            src="ecoseternos_isologo.svg"
            alt=""
            class="h-10 md:h-14 w-auto transition-transform group-hover:scale-105"
          />
          <img
            src="ecoseternos_logo_name_off_white.svg"
            alt="ECOS ETERNOS"
            class="h-7 md:h-11 w-auto"
          />
        </a>

        <!-- Botón de Perfil -->
        <button matIconButton [matMenuTriggerFor]="menu">
          <mat-icon class="!text-light">person</mat-icon>
        </button>

        <mat-menu #menu="matMenu" [xPosition]="'before'">
          <div class="px-3 pb-3 pt-1 border-b border-secondary/30">
            <p class="text-sm font-medium text-gray-900">
              {{
                (authService.currentUser?.user_metadata)!['display_name'] ??
                  authService.currentUser?.email
              }}
            </p>
          </div>

          <button mat-menu-item [matMenuTriggerFor]="langMenu">
            <span>{{ 'common.language' | transloco }}</span>
          </button>

          <button mat-menu-item (click)="logout()">
            <span>{{ 'actions.logout' | transloco }}</span>
          </button>
          <div class="px-3">
            <p class="text-sm font-medium text-tertiary/45 text-end">{{ appVersion }}</p>
          </div>
        </mat-menu>

        <mat-menu #langMenu="matMenu">
          <button mat-menu-item (click)="i18n.setLanguage('es')">
            <div class="flex flex-row">
              <div class="text-lg leading-none">
                <mat-icon
                  [inline]="true"
                  class="!size-[18px]"
                  [class.invisible]="i18n.getActiveLang() !== 'es'"
                  >check</mat-icon
                >
              </div>
              Español
            </div>
          </button>
          <button mat-menu-item (click)="i18n.setLanguage('en')">
            <div class="flex flex-row">
              <div class="text-lg leading-none">
                <mat-icon
                  [inline]="true"
                  class="!size-[18px]"
                  [class.invisible]="i18n.getActiveLang() !== 'en'"
                  >check</mat-icon
                >
              </div>
              English
            </div>
          </button>
          <button mat-menu-item (click)="i18n.setLanguage('pt')">
            <div class="flex flex-row">
              <div class="text-lg leading-none">
                <mat-icon
                  [inline]="true"
                  class="!size-[18px]"
                  [class.invisible]="i18n.getActiveLang() !== 'pt'"
                  >check</mat-icon
                >
              </div>
              Português
            </div>
          </button>
        </mat-menu>
      </div>
    </div>
  </header>

  <main class="pt-16 md:pt-20">
    <router-outlet></router-outlet>
  </main>
</div>
